import React from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';

import { IS_WEB } from '../../lib/appConstants';
import { WHITE_COLOR } from '../styleConstants';
import Portal from './Portal';

const styles = StyleSheet.create({
  overlay: {
    position: IS_WEB ? 'fixed' : 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'black',
    opacity: 0.5,
  },
  loading: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

type Props = {
  loading: boolean;
  style?: any;
};

const Overlay = ({ loading, style }: Props) => {
  const children = (
    <View style={[styles.overlay, style, { zIndex: !loading ? 5 : 99999 }]}>
      {loading && <ActivityIndicator color={WHITE_COLOR} style={styles.loading} />}
    </View>
  );

  return IS_WEB && loading ? <Portal>{children}</Portal> : children;
};

Overlay.defaultPropTypes = {
  loading: true,
};

export default Overlay;
